import client from '../client';

/**
 * 신한 SIGN 본인확인 요청 (PUSH 방식)
 * POST /api/v2/shinhan/auth/request
 */
export const callShinhanAuthRequest = async ({ userName, userBirth, userHpNo }) => {
  const params = new URLSearchParams();
  params.append('triggerType', 'PUSH');
  params.append('userInfoType', 'PROFILE');
  params.append('userName', userName);
  params.append('userBirth', userBirth);
  params.append('userHpNo', userHpNo);

  const result = await client
    .post('/api/v2/shinhan/auth/request', params)
    .then((res) => {
      const resultData = res.data && res.data.data && res.data.data.result;
      if (res.data.status === 0 && resultData && resultData.stdErrCd === '0000') {
        return { success: true, data: resultData };
      }
      return {
        success: false,
        message: (resultData && resultData.stdErrMsg) || '신한 인증 요청에 실패했습니다.',
      };
    })
    .catch((e) => {
      console.error(e);
      return { success: false, message: '신한 인증 요청 중 오류가 발생했습니다.' };
    });

  return result;
};

/**
 * 신한 SIGN 본인확인 결과 조회
 * POST /api/v2/shinhan/auth/result
 */
export const callShinhanAuthResult = async ({ signTxId, certTxId }) => {
  const params = new URLSearchParams();
  params.append('signTxId', signTxId);
  params.append('certTxId', certTxId);

  const result = await client
    .post('/api/v2/shinhan/auth/result', params)
    .then((res) => {
      if (res.data && res.data.status === 0) {
        return { success: true, data: res.data.data.result };
      }
      return {
        success: false,
        status: res.data.status,
        message: res.data.message || '신한 인증 결과 조회에 실패했습니다.',
      };
    })
    .catch((e) => {
      console.error(e);
      return { success: false, message: '신한 인증 결과 조회 중 오류가 발생했습니다.' };
    });

  return result;
};

/**
 * 신한 SIGN 인증을 통한 휴면 계정 해제
 * POST /api/v2/shinhan/awake
 */
export const callShinhanAwake = async ({ simpleId, certData }) => {
  const params = new URLSearchParams();
  params.append('simpleId', simpleId);
  params.append('certData', certData);

  const result = await client
    .post('/api/v2/shinhan/awake', params)
    .then((res) => {
      if (res.data && res.data.status === 0
          && res.data.data && res.data.data.sMessage === '정상처리 되었습니다.') {
        return true;
      }
      return false;
    })
    .catch((e) => {
      console.error(e);
      return false;
    });

  return result;
};

/**
 * 신한 SIGN 인증을 통한 만 14세 미만 재인증
 * POST /api/v2/shinhan/children/re-cert
 */
export const callShinhanRecertChildren = async ({ simpleId, certData }) => {
  const params = new URLSearchParams();
  params.append('simpleId', simpleId);
  params.append('certData', certData);

  const result = await client
    .post('/api/v2/shinhan/children/re-cert', params)
    .then((res) => {
      if (res.data && res.data.status === 0
          && res.data.data && res.data.data.sMessage === '정상처리 되었습니다.') {
        return true;
      }
      return false;
    })
    .catch((e) => {
      console.error(e);
      return false;
    });

  return result;
};
